import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import config from "../../config";

const API_SERVER =
  config.API_SERVER;

function ResaleDashboard() {

  const [loading, setLoading] =
    useState(true);

  const [dashboardData, setDashboardData] =
    useState({

      inventory_count: 0,

      pending_refurbishment: 0,

      approved_refurbishment: 0,

      intray_count: 0,

      outray_count: 0

    });

  useEffect(() => {

    fetchDashboardData();

  }, []);

  const fetchDashboardData =
    async () => {

      try {

        setLoading(true);

        const response =
          await axios.get(

            `${API_SERVER}/getResaleDashboardData`

          );

        if (
          response.data.status
        ) {

          setDashboardData(
            response.data.data
          );
        }

      } catch (error) {

        console.log(error);

      } finally {

        setLoading(false);
      }
    };

  const cards = [

    {

      title:
        "Total Inventory",

      value:
        dashboardData.inventory_count
    },

    {

      title:
        "Pending Refurbishment",

      value:
        dashboardData.pending_refurbishment
    },

    {

      title:
        "Approved Refurbishment",

      value:
        dashboardData.approved_refurbishment
    },

    {

      title:
        "Intray Count",

      value:
        dashboardData.intray_count
    },

    {

      title:
        "Outray Count",

      value:
        dashboardData.outray_count
    }

  ];

  return (

    <div className="container-fluid py-4">

      <div className="card border-0 shadow-sm">

        <div className="card-body">

          <div className="mb-4">

            <h2 className="fw-bold mb-1">

              Resale Dashboard

            </h2>

            <p className="text-muted mb-0">

              Vehicle resale inventory overview

            </p>

          </div>

          {
            loading ? (

              <div className="text-center py-5">

                <div
                  className="spinner-border text-primary"
                  role="status"
                />

              </div>

            ) : (

              <div className="row">

                {
                  cards.map(
                    (
                      item,
                      index
                    ) => (

                      <div
                        className="col-md-4 col-lg-3 mb-4"
                        key={index}
                      >

                        <div className="card border-0 shadow-sm h-100">

                          <div className="card-body">

                            <h6 className="text-muted mb-2">

                              {
                                item.title
                              }

                            </h6>

                            <h2 className="fw-bold mb-0">

                              {
                                item.value
                              }

                            </h2>

                          </div>

                        </div>

                      </div>
                    )
                  )
                }

              </div>
            )
          }

        </div>

      </div>

    </div>
  );
}

export default ResaleDashboard;